import { SupportedTags } from '../platform';

export interface ChatConfig {
    platform: string;
}

export const DefaultChatConfig: ChatConfig = {
    platform: SupportedTags.APPAREL_ORDER,
};
